import { render } from "./Configurator.vue?vue&type=template&id=2283b70c"
import script from "./Configurator.vue?vue&type=script&lang=js"
export * from "./Configurator.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/ZEPPELIN/mi-stock-zeppelin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__